var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "store_blocks" },
    [
      _c("div", { staticClass: "selected_store" }, [
        _vm._v(
          "\n    " + _vm._s(_vm.$AllStores[_vm.storeId]?.short_title) + ": "
        ),
        _c("strong", [_vm._v(_vm._s(_vm.storeStatus[_vm.storeId] ?? 0))]),
      ]),
      _vm._v(" "),
      _vm._l(_vm.$StoreRelations[_vm.storeId] ?? [], function (storeId, index) {
        return _c("div", [
          _vm._v(
            "\n    " + _vm._s(_vm.$AllStores[storeId]?.short_title) + ": "
          ),
          _c("strong", [_vm._v(_vm._s(_vm.storeStatus[storeId] ?? 0))]),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }